import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule, Routes } from "@angular/router";
import { ChangeAddressComponent } from './change-address.component';
import {MatCardModule} from "@angular/material/card";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";
import {FabExtendedModule} from "../../../components/button/fab/fab-extended/fab-extended.module";
import {MatButtonModule} from "@angular/material/button";
import {LoadingButtonModule} from "../../../components/button/loading-button/loading-button.module";

const routes: Routes = [
  {
    path: '',
    component: ChangeAddressComponent
  }
];

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    FormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    FabExtendedModule,
    MatButtonModule,
    LoadingButtonModule
  ],
  declarations: [ ChangeAddressComponent ]
})
export class ChangeAddressModule { }
